import * as yup from 'yup';

import { ObjectTypeBase } from '../baseTypes/ObjectTypeBase';
import { createShapeFromProperties } from '../properties';
import { PropertiesInterface } from '../properties/Property';
import { AllTypeContexts } from '../properties/TypeContextEnum';
import { Types } from '../properties/Types';
import { UpdateCutoffUnitEnum } from './UpdateCutoffUnitEnum';

const properties: PropertiesInterface = {
  allGroupRoles: {
    friendlyName:
      'web.content.feature.update.rules.allGroupRoles.friendlyName',
    description:
      'web.content.feature.update.rules.allGroupRoles.description',
    type: 'Boolean',
    editable: true,
    default: true,
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  groupRoles: {
    showControl: {
      _bind: true,
      op: '!props.allGroupRoles',
    },
    friendlyName:
    'web.content.feature.update.rules.groupRoles.friendlyName',
    description: 'web.content.feature.update.rules.groupRoles.description',
    type: 'GroupRole',
    editable: true,
    isArray: true,
    default: [],
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  canUpdateAnytime: {
    friendlyName:
      'web.content.feature.update.rules.canUpdateAnytime.friendlyName',
    description:
      'web.content.feature.update.rules.canUpdateAnytime.description',
    type: 'Boolean',
    editable: true,
    default: true,
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  cutoffUnit: {
    friendlyName: 'web.content.feature.update.rules.cutoffUnit.friendlyName',
    description: 'web.content.feature.update.rules.cutoffUnit.description',
    showControl: {
      _bind: true,
      op: '!props.canUpdateAnytime',
    },
    type: 'String',
    editable: true,
    default: UpdateCutoffUnitEnum.Hour,
    validators: [
      {
        name: 'In',
        value: Object.values(UpdateCutoffUnitEnum),
      },
    ],
  },
  cutoffValue: {
    friendlyName: 'web.content.feature.update.rules.cutoffValue.friendlyName',
    description: 'web.content.feature.update.rules.cutoffValue.description',
    showControl: {
      _bind: true,
      op: '!props.canUpdateAnytime',
    },
    type: 'Number',
    editable: true,
    default: 1,
    validators: [
      {
        name: 'Required',
        value: true,
      },
      {
        name: 'Min',
        value: 1,
      },
      {
        name: 'Max',
        value: 120,
      },
    ],
  },
};

export class UpdateFeatureRuleType extends ObjectTypeBase {
  name = 'UpdateFeatureRule';

  friendlyName = 'Update Rule';

  contexts = AllTypeContexts;

  get example() {
    return {
      allGroupRoles: true,
      canUpdateAnytime: true,
      groupRoles: [],
      cutoffUnit: UpdateCutoffUnitEnum.Hour,
      cutoffValue: 1,
    };
  }

  get default(): any {
    return {
      groupRoles: [],
      allGroupRoles: true,
      canUpdateAnytime: true,
      cutoffUnit: UpdateCutoffUnitEnum.Hour,
      cutoffValue: 1,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }

  properties = properties;
}

const definition = new UpdateFeatureRuleType();

Types.addType(definition);
export { definition as UpdateFeatureRuleTypeDefinition };
